import { createApp } from 'vue'
import App from './App.vue'
import i18n from '@gd/i18n'
import GDModal, { loadModalComponents } from '@gd/modal'
import { loadTComponents } from '@gd/t-components'
import '@gd/modal/dist/gd-modal.css'
import '@gd/t-components/dist/t-components.css'
import '@/styles/index.less'
import { Storage, STORE_NAME } from '@gd/storage'
import { getCookieProperty } from './lib/cookie'

// Vue.use(VueTrack, {
//   key: 'consent-web', // will be used for all tracking
//   log: true, // enable the log - default false
// })

const storage = new Storage()
const decisions = storage.read(STORE_NAME.GD).decisions

if (/cookieConsent/.test(location.search) || decisions.indexOf('fe-cookie-consent') !== -1) {
  const cookieConsent = getCookieProperty(document.cookie, 'cookieConsent')
  const storageConsent = storage.read(STORE_NAME.GD).cookieConsent

  storage.write(STORE_NAME.GD, {
    cookieConsent: {
      ...storageConsent,
      ...cookieConsent,
    },
  })

  const app = createApp(App).use(i18n)
  loadTComponents(app)
  loadModalComponents(app)
  app.component('gd-modal', GDModal)
  app.mount(document.body.appendChild(document.createElement('div')))
}
